import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import PCContainer from "../../components/atoms/layout/pcContainer";

import useDisplay from "../../hooks/useDisplay";
import LSRgDisplay02 from "../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";

import TextFormEditor from "../../components/atoms/input/textFormEditor";
import MainBtn from "../../components/atoms/button/mainBtn";
import LSRgBody01 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import InputField from "../../components/atoms/input/inputField";

import CommunityApi from "../../api/community.api";
import { errorHandler } from "../../util/errorHandler";
import SelecteBoxValue from "../../components/organisms/selectbox/selecteBoxValue";
import { toast } from "react-toastify";
import { route } from "../../router/route";
import { hasEditorContent } from "../../util/editorContent";

const CommunityCreate = () => {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [boardOpen, setBoardOpen] = useState(false);
  const [boardValue, setBoardValue] = useState("");

  const [boardList, setBoardList] = useState([]);

  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("글쓰기를 위해 로그인을 해주세요.");
      navigate(route.login, {
        replace: true,
        state: { path: window.location.href },
      });
      return;
    }

    categoryListFunc();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const categoryListFunc = async () => {
    try {
      const columnCList = (
        await CommunityApi.getCategoryList({
          page: 1,
          size: 0,
          activation: "Active",
        })
      ).data.data.content;

      const categoryTemp = (columnCList ?? []).map((item) => {
        return {
          ...item,
          value: item.id,
        };
      });

      setBoardList(categoryTemp);
    } catch (error) {
      errorHandler(error);
    }
  };

  const addCommunityFunc = async () => {
    if (isLoading) {
      toast("이미지 업로드가 완료될 때까지 기다려주세요.");
      return;
    }
    if (isSubmitting) return;

    const trimmedTitle = title.trim();
    try {
      const categoryId = Number(boardValue);
      if (!Number.isInteger(categoryId) || categoryId <= 0) {
        return toast("게시판을 선택해주세요.");
      }

      if (!trimmedTitle) {
        return toast("제목을 입력해주세요.");
      }

      if (!hasEditorContent(content)) {
        return toast("상세 내용을 입력해주세요.");
      }

      setIsSubmitting(true);
      const data = {
        communityCategoryId: categoryId,
        title: trimmedTitle,
        content: content,
      };
      const response = await CommunityApi.register(data);
      const createdId = response.data.data.id;

      toast("글쓰기를 등록하였습니다.");
      navigate(`${route.community_detail}/${createdId}`, { replace: true });
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <CommunityCreateSection>
        <PCContainer
          style={{
            flexDirection: "column",
            padding: isMobile
              ? "40px 20px 80px 20px"
              : isTablet
                ? "40px 60px 80px 60px"
                : "80px 0px 150px 0px",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <LSRgDisplay02
              style={{
                color: "#000000",
                marginBottom: isMobile ? 16 : isTablet ? 30 : 32,
                fontSize: isMobile ? 16 : 24,
                lineHeight: isMobile ? "22.4px" : "33.6px",
              }}
            >
              글쓰기
            </LSRgDisplay02>

            {isMobile ? null : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <MainBtn
                  onClick={() => {
                    navigate(-1);
                  }}
                  style={{
                    width: 72,
                    height: 36,
                    background: "#F6F7F8",
                    marginRight: 10,
                    borderRadius: 8,
                  }}
                >
                  <LSRgBody01
                    style={{
                      color: "#A4A8B1",
                      textAlign: "center",
                    }}
                  >
                    취소
                  </LSRgBody01>
                </MainBtn>
                <MainBtn
                  disabled={isLoading || isSubmitting}
                  onClick={() => {
                    addCommunityFunc();
                  }}
                  style={{
                    width: 72,
                    height: 36,
                    borderRadius: 8,
                  }}
                >
                  <LSRgBody01
                    style={{
                      color: "#FFFFFF",
                      textAlign: "center",
                    }}
                  >
                    {isSubmitting ? "등록 중" : "글쓰기"}
                  </LSRgBody01>
                </MainBtn>
              </div>
            )}
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              alignItems: "center",
              marginBottom: isMobile ? 16 : 20,
            }}
          >
            <SelecteBoxValue
              style={{
                width: isMobile ? "100%" : 278,
                marginRight: isMobile ? 0 : 16,
                marginBottom: isMobile ? 16 : 0,
              }}
              isSmall={true}
              selectedValue={boardValue}
              isOpen={boardOpen}
              wrapperHandler={() => {
                setBoardOpen(!boardOpen);
              }}
              itemList={boardList}
              selectedValueSetterFunc={setBoardValue}
              placeholder={"게시판 선택"}
            />

            <InputField
              id="title"
              name="title"
              placeholder="제목을 입력해 주세요."
              type="text"
              autoComplete="off"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
              containerStyle={{
                width: isMobile ? "100%" : 585,
                height: 56,
              }}
              style={{
                margin: "15px 15px",
              }}
            />
          </div>

          <TextFormEditor
            placeholder={"상세 내용을 입력해주세요"}
            value={content}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            onChange={(e) => {
              setContent(e);
            }}
            editorHeight={isMobile ? 500 : 700}
            style={{
              width: "100%",
            }}
          />

          {isMobile ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: 50,
              }}
            >
              <MainBtn
                onClick={() => {
                  navigate(-1);
                }}
                style={{
                  background: "#F6F7F8",
                  marginRight: isMobile ? 8 : 10,
                }}
              >
                <LSRgBody01
                  style={{
                    color: "#A4A8B1",
                    textAlign: "center",
                  }}
                >
                  취소
                </LSRgBody01>
              </MainBtn>
              <MainBtn
                disabled={isLoading || isSubmitting}
                onClick={() => {
                  addCommunityFunc();
                }}
                style={{}}
              >
                <LSRgBody01
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                  }}
                >
                  {isSubmitting ? "등록 중" : "글쓰기"}
                </LSRgBody01>
              </MainBtn>
            </div>
          ) : null}
        </PCContainer>
      </CommunityCreateSection>
    </>
  );
};

export default CommunityCreate;

const CommunityCreateSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;
